<template>
  <v-container grid-list-xl fluid v-if="selectedSurvey">
    <v-layout row wrap>
      <v-flex xs6>
        <v-tooltip bottom>
          <template slot="activator">
            {{selectedSurvey.title}}
            <v-icon color="primary">info</v-icon>
          </template>
          <span>
            <ul>
              <li>Created by: {{selectedSurvey.owner_name}}</li>
              <li>Type: {{selectedSurvey.type}}</li>
              <li>Created at: {{selectedSurvey.created_at}}</li>
            </ul>
            </span>
        </v-tooltip>
      </v-flex>

      <v-flex xs6 class="text-xs-right">
        <v-btn
          v-if="showComponentsEmailSurvey"
          @click="showModal.emailConfiguration = true"
        >
          <v-icon dark>mdi-wrench</v-icon>
          Email configuration
           <v-icon class="ml-2">settings</v-icon>
        </v-btn>
        <v-btn
          v-if="showComponentsEmailSurvey"
          @click="showModal.sendEmailTest = true"
        >
          Send email test
          <v-icon class="ml-2">email</v-icon>
        </v-btn>
        <v-btn
          v-if="showComponentsEmailSurvey && currentRound && !currentRound.status"
          color="primary"
          @click="showModal.activateRound = true"
        >
          Activate Round
        </v-btn>
        
        <v-btn
          v-if="showComponentsDevicesSurvey && currentRound && !currentRound.status && !showcomponentManager"
          color="primary"
          @click="activateRoundDevices"
        >
          Activate Round
        </v-btn>
        <v-btn
          color="success"
          v-if="showComponentsDevicesSurvey && currentRound && currentRound.status && !showcomponentManager"
          @click="editRoundDevices"
        >
          Edit
        </v-btn>
        
      </v-flex>
      <v-flex xs12>
          <v-tabs v-model="tab" color="blue lighten-5">
            <v-tab v-for="(round, key) in rounds" :key="key" ripple>
              <div>
                <v-badge color="green" slot="activator">
                  <template slot="badge" v-if="round.status">
                    <v-icon dark small>check</v-icon>
                  </template>
                  <span>{{ round.name }}</span>
                </v-badge>
              </div>
            </v-tab>
            <v-btn flat @click="openModalCreateRound" v-if="showComponentsEmailSurvey">
              <v-icon color="grey darken-3">add</v-icon> CREATE
            </v-btn>
            <v-tab-item v-for="(round, key) in rounds" :key="key">
              <showRound :round="round"></showRound>
            </v-tab-item>
          </v-tabs>
      </v-flex>

      <modal-create-round
        v-if="showModal.addRound"
        :showModal="showModal.addRound"
        @close-modal-create-round="showModal.addRound = false"
        @add-round="addRoundToList"
      ></modal-create-round>

      <modal-email-configuration
        v-if="showModal.emailConfiguration"
        :round="currentRound"
        :showModal="showModal.emailConfiguration"
        @close-modal-email-configuration="showModal.emailConfiguration = false"
      ></modal-email-configuration>

      <modal-send-email-test
        v-if="showModal.sendEmailTest"
        :round="currentRound"
        :showModal="showModal.sendEmailTest"
        @close-modal-send-email-test="showModal.sendEmailTest = false"
      ></modal-send-email-test>

      <modal-activate-round
        v-if="showModal.activateRound"
        :round="currentRound"
        :showModal="showModal.activateRound"
        @close-modal-activate-round="showModal.activateRound = false"
        @activate-round="activateRound()"
      ></modal-activate-round>
      
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ShowRound from '@/components/client/rounds/Show.vue';
import ModalCreateRound from '@/components/client/rounds/modals/CreateRound.vue';
import ModalEmailConfiguration from '@/components/client/rounds/modals/EmailConfiguration.vue';
import ModalSendEmailTest from '@/components/client/rounds/modals/EmailTest.vue';
import ModalActivateRound from '@/components/client/rounds/modals/ActivateRound.vue';

export default {
  components: {
    ModalEmailConfiguration,
    ShowRound,
    ModalCreateRound,
    ModalSendEmailTest,
    ModalActivateRound
  },
  data () {
    return {
      surveyId: null,
      rounds: [],
      showModal: {
        emailConfiguration: false,
        emailTest: false,
        addRound: false,
        sendEmailTest: false,
        activateRound: false
      },
      panelGeneral: [true],
      tab: '0'
    };
  },  
  computed: {
    ...mapGetters('survey', ['selectedSurvey']),
    ...mapGetters(['currentUser']),
    showcomponentManager: function () {
      if (this.currentUser.role === 'manager') {
        return true;
      }
      return false;
    },
    showComponentsEmailSurvey: function () {
      if (this.selectedSurvey.type === 'mailing' || this.selectedSurvey.type === 'extended' || this.selectedSurvey.type === 'custom') {
        return true;
      }
      return false;
    },
    showComponentsDevicesSurvey: function () {
      if (this.selectedSurvey.type === 'devices') {
        return true;
      }
      return false;
    },
    showComponentsLaboralSurvey: function () {
      return false;
    },
    currentRound: function () {
      return this.rounds[this.tab];
    }
  },
  created: function () {
    this.surveyId = this.$route.params.survey_id;
    this.loadRoundsData();
  },
  mounted () {
    this.loadData();
  },
  methods: {
    ...mapActions('survey', [
      'callSelectedSurvey'
    ]),
    ...mapActions(['setSnackbar', 'setLoading']),
    loadData () {
      const url = `surveys/${this.surveyId}/show`;
      window.axios.get(url)
        .then(response => {
          this.callSelectedSurvey(response.data.data);
        })
        .catch(error => {
          this.$store.commit('setLoading', false);
        });
    },
    loadRoundsData () {
      this.setLoading(true);
      const url = `surveys/${this.surveyId}/rounds`;
      window.axios.get(url)
        .then(response => {
          this.setLoading(false);
          this.rounds = response.data.data;
        })
        .catch(error => {
          this.setLoading(false);
          this.setSnackbar({
            show: true,
            color: 'red',
            text: 'Survey show error!'
          });
        });
    },
    openModalCreateRound () {
      this.showModal.addRound = true;
    },
    addRoundToList (data) {
      this.rounds.push(data);
      this.tab = this.rounds.length - 1;
      this.tab = this.tab.toString();
    },
    activateRound () {
      if (!this.currentRound.name_from_email || !this.currentRound.from_email || !this.currentRound.subject_email) {
        this.setSnackbar({
          show: true,
          color: 'error',
          text: 'The subject fields of the mail, name and mail, can not be empty.'
        });
        return false;
      }
      this.showModal.activateRound = false;
      const url = `rounds/${this.currentRound.id}/activate-round`;
      window.axios.get(url).then(response => {
        this.currentRound.status = true;
        this.$store.dispatch('setSnackbar', {
          show: true,
          color: 'green',
          text: 'Survey activated successfully'
        });
      });
    },
    activateRoundDevices () {
      const url = `rounds/${this.currentRound.id}/activate-round`;
      window.axios.get(url).then(response => {
        this.currentRound.status = true;
        this.$store.dispatch('setSnackbar', {
          show: true,
          color: 'green',
          text: 'Survey activated successfully'
        });
      });
    },
    editRoundDevices () {
      const url = `rounds/${this.currentRound.id}/edit-devices-round`;
      window.axios.get(url).then(response => {
        this.currentRound.status = false;
      });
    }
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/client/surveys/Show.vue